import Chip from '@mui/material/Chip'
import { buildPillChipSx } from './pillChipSx.js'

export default function PillView({
  label,
  icon = null,
  active = false,
  disabled = false,
  onClick,
  surface,
  shape,
  'aria-pressed': ariaPressed,
  'aria-label': ariaLabel,
}) {
  const interactive = !disabled && typeof onClick === 'function'

  return (
    <Chip
      label={label}
      icon={icon ?? undefined}
      size="small"
      clickable={interactive}
      disabled={disabled}
      onClick={interactive ? onClick : undefined}
      aria-pressed={disabled ? undefined : ariaPressed}
      aria-label={ariaLabel ?? label}
      variant="outlined"
      sx={buildPillChipSx(active, interactive, { surface, shape })}
    />
  )
}
